import React from 'react';
import { StatusBar, Platform } from 'react-native';
import { AuthProvider } from './src/contexts/AuthContext';
import { ArticleProvider } from './src/contexts/ArticleContext';
import AppNavigator from './src/navigation/AppNavigator';
import PWAInstallPrompt from './src/components/PWAInstallPrompt';

export default function App() {
  return (
    <AuthProvider>
      <ArticleProvider>
        <StatusBar barStyle="light-content" backgroundColor="#2E7D32" />
        <AppNavigator />
        {Platform.OS === 'web' && <PWAInstallPrompt />}
      </ArticleProvider>
    </AuthProvider>
  );
}
